/**
 * @file
 * Extends the Drupal js.
 */

(($, Drupal) => {
  /**
   * Initialize dialogs for Ajax purposes.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the behaviors for dialog ajax functionality.
   */
  Drupal.behaviors.global = {
    attach: function attach(context, settings) {
      //Home Page - Animated Section
      $(document).on('click', '#view-products-submenu, #view-products-submenu-mobile', function () {
      // Delay to ensure the click actions happen in sequence
      setTimeout(function () {
        // Click to open the Mobile hamburger menu
        $('.tbm-button-container').click();

        // Add 'open' class to the 'products and brands' menu
        $('.tbm-nav .products-brands-menu').addClass('open');

        // Open the first submenu item in 'brands'
        $('.tbm-subnav .food-menu').addClass('open').focus();

        $('html, body').animate({
          scrollTop: $('.tbm-nav .products-brands-menu').offset().top
        }, 200);

      }, 100);
    });

    //Recipe filter
    $('#btn-recipe-filter').on('click', function (event) {
      event.preventDefault();
      var $collapseElement = $('#recipeSearchFilterCcollapse');
      var isExpanded = $(this).attr('aria-expanded') === 'true';

      if (isExpanded) {
          $collapseElement.animate({ height: '0px', opacity: 0 }, 500, function () {
              $collapseElement.removeClass('show').css('display', 'none');
          });
      } else {
          $collapseElement.css({ display: 'flex', height: 'auto', opacity: 1 });
          var autoHeight = $collapseElement.outerHeight();
          $collapseElement.css({ height: '0px', opacity: 0 }).animate({ height: autoHeight + 'px', opacity: 1 }, 500, function () {
              $collapseElement.addClass('show').css('height', 'auto');
          });
      }

      // Update aria-expanded attribute
      $(this).attr('aria-expanded', !isExpanded);
    });

    // Update select field title for chosen opt
    $(".webform-brazil-hub-contact-us #edit-date-list-month").on("change", function () {
        let selectedText = $(this).find("option:selected").map(function () {
            return $(this).text();
        }).get().join(", ");
        $(this).attr("title", selectedText);
    }).trigger("change");

    //prevent scrolling of body when modal open
    $('.modal').on('show.bs.modal', function () {
      $('body').addClass('modal-open');
    });

    $('.modal').on('hide.bs.modal', function () {
      $('body').removeClass('modal-open');
    });

        // Header navbar overflow logic
    function checkNavbarOverflow() {
      var $nav = $('.tbm-main');
      var $navbar = $('.navbar');
      var $collapse = $('.navbar-collapse');

      if (!$nav.length || !$navbar.length || !$collapse.length) return;

      var windowWidth = $(window).width();

      // Only run overflow logic above 992px
      if (windowWidth > 992) {
        var collapseWidth = $collapse[0].scrollWidth;
        // Check if the collapse element's width exceeds the navbar's width
        if (collapseWidth > windowWidth) {
          $navbar.addClass('overflowed-menu');
          $nav.addClass('tbm--mobile');
        } else {
          $navbar.removeClass('overflowed-menu');
          $nav.removeClass('tbm--mobile');
        }
      } 
    }

    // Run on full page load and resize
    $(window).on('load resize', function () {
      setTimeout(checkNavbarOverflow, 50);
    });

    var s = $(".promo-menu");
    if (s.length) {
      var initialTop;

      function recalcTop() {
        var $m = $(".promo-menu");
        if (!$m.length) return;
        $m.removeClass("stick");               // measure from non-sticky position
        initialTop = $m.offset().top;
      }

      // initial measure
      recalcTop();

      // single namespaced scroll handler; always act on the current element
      $(window)
        .off("scroll.promoMenuStick")
        .on("scroll.promoMenuStick", function () {
          var $m = $(".promo-menu");
          if (!$m.length) return;

          var windowTop = $(this).scrollTop();
          if (windowTop >= initialTop) {
            $m.addClass("stick");
          } else {
            $m.removeClass("stick");
          }
        })
        .trigger("scroll");

      // recompute after AJAX pager updates and on resize, then apply state
      $(document).off("ajaxComplete.promoMenuStick").on("ajaxComplete.promoMenuStick", function () {
        recalcTop();
        $(window).trigger("scroll.promoMenuStick");
      });
      $(window).off("resize.promoMenuStick").on("resize.promoMenuStick", function () {
        recalcTop();
        $(window).trigger("scroll.promoMenuStick");
      });

        // Bootstrap modal close 
      $(document).on("hidden.bs.modal dialogclose", function () {
        $(".promo-menu").removeClass("stick");
        setTimeout(function () {
          recalcTop();
          $(window).trigger("scroll.promoMenuStick");
        }, 50);
      });


    }

      let sections = $(".block");
      let navlinks = $(".promo-menu a");

      function setActiveLink() {
        let scrollPosition = $(window).scrollTop();
        sections.each(function () {
          let sectionOffset = $(this).offset().top - 10;
          let sectionHeight = $(this).outerHeight();
          let sectionId = $(this).attr('id');

          if (scrollPosition >= sectionOffset - 100 && scrollPosition < sectionOffset + sectionHeight - 100) {
            navlinks.removeClass('active');
            $('.promo-menu a[href="#' + sectionId + '"]').addClass('active');
          }
        });
      }

      //smooth scroll 
      $('a[href^="#"]').on('click', function (event) {
        var href = this.getAttribute('href');
        // Avoid selecting empty hashes
        if (href !== "#") { 
            var target = $(href);
            if (target.length) {
                event.preventDefault();
                $('html, body').stop().animate({
                    scrollTop: target.offset().top - 100
                }, 10, function () {
                    setActiveLink();
                });
            }
        }
      });
    
    $(window).on('scroll', setActiveLink);
    

      const toggleUserAccount = () => {
      const burgerIcon = document.querySelector('.tbm-button');
      const navbarAccountUser = document.querySelector('.navbar-menu > .block-pepsico-user-account-menu-block .navbar-account-user');
      const brandingBlock = document.querySelector('.navbar .block-system-branding-block');

      if (burgerIcon && navbarAccountUser && brandingBlock) {
        burgerIcon.addEventListener('click', () => {
          const aria = burgerIcon.getAttribute('aria-expanded');
          if (aria === 'true') {
            navbarAccountUser.classList.add('hidden');
            brandingBlock.classList.add('align-right')
          } else {
            navbarAccountUser.classList.remove('hidden');
            brandingBlock.classList.remove('align-right');
          }
        });
      }

    }
    toggleUserAccount();
    // remove br tags in the form description feild
    $(".js-form-type-managed-file .webform-element-description br").replaceWith("&nbsp;");
  },
  };
})(jQuery, Drupal);


//New loader for forms
(function (Drupal, once, $) {
  Drupal.behaviors.customLoader = {
    attach: function (context) {
      const forms = once('customLoader', 'form:not(.ajax-comments-form-add)', context); // Exclude comment form

      forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
          if (submitButton) {
            // Prevent duplicate loader spinner
            if (submitButton.parentNode.querySelector('.loader-spinner')) {
              submitButton.parentNode.querySelectorAll('.loader-spinner').forEach(el => el.remove());
            }
            const loaderSpan = document.createElement('span');
            loaderSpan.className = 'loader-spinner';
            submitButton.parentNode.insertBefore(loaderSpan, submitButton.nextSibling);
            submitButton.setAttribute('disabled', 'true');

            window.addEventListener('load', () => {
              const spinner = submitButton.parentNode.querySelector('.loader-spinner');
              if (spinner) spinner.remove();
              submitButton.removeAttribute('disabled');
            });

            const checkForErrors = () => {
              const errorMessages = form.querySelectorAll('.error, .messages--error, .invalid-feedback, .is-invalid, .alert-danger');
              if (errorMessages.length > 0) {
                const spinner = submitButton.parentNode.querySelector('.loader-spinner');
                if (spinner) spinner.remove();
                submitButton.removeAttribute('disabled');
              }
            };

            setTimeout(checkForErrors, 1000);

            const observer = new MutationObserver(() => {
              if (document.querySelector('.alert-danger')) {
                const spinner = submitButton.parentNode.querySelector('.loader-spinner');
                if (spinner) spinner.remove();
                submitButton.removeAttribute('disabled');
                observer.disconnect();
              }
            });

            observer.observe(document.body, { childList: true, subtree: true });
          }
        });
      });

      $(document).on('ajaxStart', function () {
        const activeElement = document.activeElement;
        if (activeElement && (activeElement.type === 'submit' || activeElement.tagName === 'BUTTON')) {
          const $submitButton = $(activeElement);
          if ($submitButton.closest('form').hasClass('ajax-comments-form-add')) return; // Skip comment form

          // Prevent duplicate spinners - only add if none exists
          if ($('.loader-spinner').length === 0) {
            const loaderSpan = $('<span class="loader-spinner"></span>');
            $submitButton.after(loaderSpan);
            $submitButton.prop('disabled', true);
            $submitButton.data('loaderSpan', loaderSpan);
          }
        }
      });

      $(document).on('ajaxComplete', function () {
        $('button:disabled, input:disabled').each(function () {
          const $submitButton = $(this);
          if ($submitButton.closest('form').hasClass('ajax-comments-form-add')) return; // Skip comment form

          const $loaderSpan = $submitButton.data('loaderSpan');
          if ($loaderSpan) {
            $loaderSpan.remove();
            $submitButton.prop('disabled', false);
            $submitButton.removeData('loaderSpan');
          }
        });
        // Clean up any remaining spinners
        $('.loader-spinner').remove();
      });

      $(document).on('ajaxError', function () {
        $('button:disabled, input:disabled').each(function () {
          const $submitButton = $(this);
          if ($submitButton.closest('form').hasClass('ajax-comments-form-add')) return; // Skip comment form

          const $loaderSpan = $submitButton.data('loaderSpan');
          if ($loaderSpan) {
            $loaderSpan.remove();
            $submitButton.prop('disabled', false);
            $submitButton.removeData('loaderSpan');
          }
        });
        // Clean up any remaining spinners
        $('.loader-spinner').remove();
      });

      // Remove loader spinner and only enable submit button if form is valid on page restore
      window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
          document.querySelectorAll('.loader-spinner').forEach(el => el.remove());
        }
      });

      // Remove loader spinner and only enable submit button if form is valid on page restore
      window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
          document.querySelectorAll('.loader-spinner').forEach(el => el.remove());
        }
      });
    },
  };
})(Drupal, once, jQuery);
